import React, { createContext, useContext, useState, useCallback } from 'react';

export interface BreadcrumbOverride {
  path: string;
  label: string;
}

interface BreadcrumbContextValue {
  overrides: BreadcrumbOverride[];
  setOverrides: (overrides: BreadcrumbOverride[]) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  overrides: [],
  setOverrides: () => {},
});

export function BreadcrumbProvider({ children }: { children: React.ReactNode }) {
  const [overrides, setOverridesState] = useState<BreadcrumbOverride[]>([]);
  const setOverrides = useCallback((o: BreadcrumbOverride[]) => setOverridesState(o), []);

  return (
    <BreadcrumbContext.Provider value={{ overrides, setOverrides }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  return useContext(BreadcrumbContext);
}
